/**
 * @param {jQuery} $
 * @param {AppConfig} config
 * @param {AppLibrary} library
 * @constructor
 */
export let Customer = function ($, config, library) {
  /**
   * @type {{id: int, referrerId: string}}
   */
  let customer = config.getCustomer();

  /**
   * @type {string}
   */
  const URL_VISITS = config.env().appApiUrl + '/customervisits';

  /**
   * @type {string}
   */
  const URL_SOCIAL = config.env().appApiUrl + '/customersocial';

  /**
   * @type {string}
   */
  const URL_DOB = config.env().appApiUrl + '/customerdob';

  /**
   * @type {string}
   */
  const COOKIE_NAME = 'visit';

  /**
   * @type {string}
   */
  const REFERRER_KEY = 'lpref';

  /**
   * @type {int}
   */
  const TAKE_VISIT_INTERVAL = 3600; // sec

  /**
   * @type {string}
   */
  let referrer = '';

  /**
   *
   */
  let init = () => {
    let _GET = library.requestGetVars();
    let referrerFromCookie = library.getCookie(REFERRER_KEY);

    if(typeof(_GET[REFERRER_KEY]) === 'string'){
      // Customer comes to site using referral link: take ref.code from url and save it cookie
      referrer = _GET[REFERRER_KEY];
      library.setCookie(REFERRER_KEY, referrer);

    }else if(typeof(referrerFromCookie) === 'string'){
      // Customer has ref.code in the cookie: take it
      referrer = referrerFromCookie;
    }

    if (referrer === customer.referrerId) {
      referrer = '';
    }
  };

  /**
   *
   */
  this.takeVisit = () => {
    if (!customer.id) {
      return;
    }

    if (!referrer) {
      let now = new Date();
      let lastTaken = (new Date(library.getCookie(COOKIE_NAME)));
      if (lastTaken.getTime() && !isNaN(lastTaken.getTime()) && Math.round((now - lastTaken) / 1000) < TAKE_VISIT_INTERVAL) {
        return;
      }
    }

    let data = {};
    if (referrer) {
      data.referrerId = referrer;
    }

    send(
        URL_VISITS,
        data,
        (response) => {
          console.log('Customer visit taken');
          library.setCookie(COOKIE_NAME, (new Date()).toString());
          if (referrer) {
            console.log('Referrer code taken');
            referrer = '';
            library.deleteCookie(REFERRER_KEY);
          }
        },
        (message) => {
          console.error(message);
        }
    );
  };

  /**
   * @param {string} social
   */
  this.takeSocialFollow = (social) => {
    if (!customer.id) {
      return;
    }
    send(
        URL_SOCIAL,
        {social: social},
        (response) => {
          console.log('Social follow taken');
        },
        (message) => {
          console.error(message);
        }
    );
  };

  /**
   * @return {string}
   */
  this.getReferralLink = () => {
    if (!customer.id) {
      return '';
    }
    let loc = document.location;
    return loc.protocol + '//' + loc.host + '/?' + REFERRER_KEY + '=' + customer.referrerId;
  };

  /**
   * @return {string}
   */
  let referrerCode = () => {
    let _GET = library.requestGetVars();
    return typeof(_GET[REFERRER_KEY] === 'string') ? _GET[REFERRER_KEY] : '';
  };

  /**
   * @param {string} url
   * @param {*} data
   * @param {function} success
   * @param {function} error
   */
  let send = (url, data, success, error) => {
    data.customer_id = customer.id;
    data.shophash = config.snippet().shopHash;
    let successOrig = success;
    success = (response) => {
      if (typeof(response.refresh) !== 'undefined' && response.refresh) {
        document.location.reload();
      }
      successOrig(response);
    };
    $.ajax({
      type: 'post',
      url: url,
      dataType: 'json',
      data: data,
      crossDomain: true,
      xhrFields: {withCredentials: false},
      success: success,
      error: (response, textStatus) => {
        let message = textStatus;
        if (response.hasOwnProperty('responseText') && response.responseText) {
          let responseText = JSON.parse(response.responseText);
          if (responseText.hasOwnProperty('message')) {
            message = responseText.message;
          }
        }
        error(message);
      }
    });
  };

  init();
};